<app-modal
  #deleteAlertsModal
  [modalMessage]="app.text.alert.deleteMessage"
  [modalTitle]="app.text.alert.modalTitle"
  (ok)="app.alerts.deleteAlerts()"
  >
</app-modal>
<app-paginator
  [length]="app.alerts.allAlerts.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator>
@if (app.table.selected.size > 0) {
  <div class="row">
    <div class="col-md-4 ps-1">
      <div class="d-inline-flex selectedAlerts">
        @if (app.table.selected.size > 0) {
          <a
            class="me-3 pointer"
            (click)="app.alerts.markAsSeeen()"
            >
            <i class="fas fa-check-double fa-green"></i> &nbsp;
            {{ app.text.alert.markAsSeen }}
          </a>
        }
        @if (app.table.selected.size > 0) {
          <a
            class="pointer"
            (click)="app.alerts.deleteAlerts()"
            >
            <i class="fas fa-trash"></i> &nbsp;
            {{ app.text.alert.deleteAllSelected }}
          </a>
        }
      </div>
    </div>
    <div class="col-md-4 text-center">
      <div class="text-center d-inline-flex selectedAlerts">
        <span> {{ app.table.selected.size }} {{ app.text.mail.selected }} </span>
        @if (app.table.selected.size !== app.alerts.allAlerts.length) {
          <a
            class="selectAllButtton"
            (click)="app.table.selectAll(app.alerts.allAlerts, true)"
            >
            {{ app.text.mail.selectAll }} {{ app.alerts.allAlerts.length }}
          </a>
        }
        @if (app.table.selected.size === app.alerts.allAlerts.length) {
          <a
            class="selectAllButtton"
            (click)="app.table.clearSelection()"
            >
            {{ app.text.mail.deselectAll }}
          </a>
        }
      </div>
    </div>
  </div>
}

<div
  class="tableFixHead"
  [ngClass]="{ tableHeight: app.filterTable.isDropdownOpen }"
  >
  <table class="table table-striped spacing-table">
    <thead>
      <tr>
        @for (column of app.alerts.columns; track column) {
          <th class="p-1">
            <div class="d-inline-flex">
              <div
              [ngClass]="{
                'resize-table': app.table.canColumnBeResized(column)
              }"
                >
                @if (column !== 'part.partsToVehicles') {
                  <span
                (click)="
                  app.table.toggleSortDirection(column);
                  app.table.sort(app.alerts.allAlerts)
                "
                    >{{ app.field.handleSpecialLogicLabels(column) }}
                  </span>
                }
                @if (column === 'part.partsToVehicles') {
                  <div>
                    <i class="fas fa-sitemap fa-rotate-270 pointer"></i>
                  </div>
                }
              </div>
              &nbsp;
              @if (column === app.table.sortField) {
                <span>
                  @if (app.table.sortDirection === 1) {
                    <i
                      class="fa fa-chevron-up"
                    ></i>
                  }
                  @if (app.table.sortDirection === -1) {
                    <i
                      class="fa fa-chevron-down"
                    ></i>
                  }
                </span>
              }
            </div>
            @if (column === 'select') {
              <div>
                @if (app.table.selected.size !== 0) {
                  <button
                    class="btn btn-hidden pt-0 ps-0"
                    (click)="app.table.clearSelection()"
                    >
                    <i class="far fa-check-square"></i>
                  </button>
                }
                @if (app.table.selected.size === 0) {
                  <button
                    class="btn btn-hidden pt-0 ps-0"
                    (click)="app.table.selectAll(app.alerts.allAlerts)"
                    >
                    <i class="far fa-square"></i>
                  </button>
                }
              </div>
            }
            @if (
              app.filterTable.getFilterTableColumns(
              app.mail.getColumnShort(column)
              )
              ) {
              <div
                >
                <app-filter-table
                  [column]="app.mail.getColumnShort(column)"
                  [columns]="app.alerts.columns"
                  [docType]="'alert'"
                  [cleanDocs]="app.alerts.cleanAlerts"
                  [selectedFilters]="selectedFilters"
                  (resultedDocs)="app.filterTable.getFilterResults($event, 'alert')"
                  >
                </app-filter-table>
              </div>
            }
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (alert of app.paginator.getPage(app.alerts.allAlerts); track alert) {
        <tr
        [ngClass]="{
          isSelected: app.isSelected(alert)
        }"
          >
          @for (column of app.alerts.columnsShort; track column) {
            <td class="p-1">
              <div>
                @switch (app.table.getColumnTypeDisplay(column)) {
                  @case ('date') {
                    <div>
                      @if (alert[column] > 0) {
                        <span>
                          {{ alert[column] | date : "yyyy-MM-dd" : "UTC" }}
                        </span>
                      }
                    </div>
                  }
                  @case ('navigateAction') {
                    <div>
                      <a class="partNumber" (click)="navigateTo(column, alert)">
                        {{ alert[column] }}
                      </a>
                    </div>
                  }
                  @case ('actions') {
                    <div>
                      @if (column === 'createCase') {
                        <div>
                          @if (
                            !app.thread.getCase(alert) &&
                            app.permission.alert.canCreateCase
                            ) {
                            <i
                              class="far fa-folder-plus click-area icon-blue pointer"
                  (click)="
                    app.thread.newCase(alert, true);
                    app.alerts.currentSelected = alert
                  "
                            ></i>
                          }
                          @if (app.thread.getCase(alert)) {
                            <i
                              class="fas fa-folder-open click-area icon-blue pointer"
                  (click)="
                    seeOpenedCasesModal.open();
                    app.alerts.currentSelected = alert;
                    app.thread.getCasesByPartNumber(alert)
                  "
                            ></i>
                          }
                        </div>
                      }
                      @if (column === 'checkedByOm') {
                        <div>
                          @if (alert.update_user !== undefined && alert[column]) {
                            <button
                              class="btn btn-hidden pt-0 ps-0"
                  [ngbTooltip]="
                    app.users.getOptionName(alert.update_user) +
                    ' ' +
                    app.text.credits.on +
                    ' ' +
                    (alert.update_time | date : 'yyyy-MM-dd')
                  "
                              >
                              <i class="fas fa-check-double fa-green"></i>
                            </button>
                          }
                          @if (alert.update_user == undefined && alert[column]) {
                            <button
                              class="btn btn-hidden pt-0 ps-0"
                              >
                              <i class="fas fa-check-double fa-green"></i>
                            </button>
                          }
                          @if (!alert[column]) {
                            <button class="btn btn-hidden pt-0 ps-0">
                              <i class="fas fa-exclamation-circle fa-orange"></i>
                            </button>
                          }
                        </div>
                      }
                      @if (column === 'select') {
                        <div>
                          @if (!alert[column]) {
                            <button
                              class="btn btn-hidden pt-0 ps-0"
                              (click)="app.table.toggleSelect(alert)"
                              >
                              @if (app.table.selected.has(alert)) {
                                <i
                                  class="far fa-check-square"
                                ></i>
                              }
                              @if (!app.table.selected.has(alert)) {
                                <i
                                  class="far fa-square"
                                ></i>
                              }
                            </button>
                          }
                        </div>
                      }
                    </div>
                  }
                  @case ('normal') {
                    <div
                      class="pointer"
                      (click)="navigateTo(column, alert)"
                      >
                      {{ alert[column] }}
                    </div>
                  }
                  @case ('textCenter') {
                    <div>
                      {{ alert[column] }}
                    </div>
                  }
                  @case ('link') {
                    <div>
                      <div class="text-center">
                        @if (alert[column]) {
                          <a [href]="alert[column]" target="_blank">
                            <i class="fas fa-file icon-blue"></i>
                          </a>
                        }
                      </div>
                    </div>
                  }
                  @case ('partsToVehicles') {
                    <div
                      >
                      <i
                        class="fas fa-sitemap fa-rotate-270 pointer icon-blue p-1"
                (click)="
                  selectedWhereUsedPartNumber = alert['partNumber'];
                  seeWhereUsedTreeModal.open();
                  $event.stopPropagation()
                "
                        [title]="app.text.part.whereUsed"
                      ></i>
                    </div>
                  }
                  @case ('getFieldValueAsText') {
                    <div>
                      @if (column === 'alertCategory') {
                        <div>
                          {{
                          app.field.getFieldValueAsText(
                          "alert." + column,
                          alert[column]
                          )
                          }}
                          @if (
                            alert['alertCategory'] === 'range_not_before_date' &&
                            alert['monitoringRangeUpTo'] > 0
                            ) {
                            <span
                              >
                              {{
                              alert["monitoringRangeUpTo"] | date : "yyyy-MM-dd" : "UTC"
                              }}
                            </span>
                          }
                        </div>
                      }
                      @if (column !== 'alertCategory') {
                        <div>
                          {{
                          app.field.getFieldValueAsText(
                          "alert." + column,
                          alert[column]
                          )
                          }}
                        </div>
                      }
                    </div>
                  }
                  @case ('optionText') {
                    <div>
                      <span
                        class="badge badgeStatus"
                [ngStyle]="
                  app.field.getColor(
                    app.fieldId.alert.criticality,
                    alert.criticality
                  )
                "
                        >
                        {{ app.field.getOptionText("alert." + column, alert[column]) }}
                      </span>
                    </div>
                  }
                  @case ('badge') {
                    <div>
                      <span
                        class="col-6 btn badge"
                [ngStyle]="
                  app.alerts.getColor(
                    'alert.' + column,
                    alert[column],
                    alert['envComplianceAlertCategory']
                  )
                "
                        [ngClass]="{ darkText: column === 'severity' }"
                        >{{
                        app.field.getOptionText("alert." + column, alert[column])
                        }}</span
                        >
                      </div>
                    }
                    @case ('limit') {
                      <div class="fixedWidth">
                        <span (click)="$event.stopPropagation()">
                          <app-limit [textInput]="alert[column]" limit="20"> </app-limit>
                        </span>
                      </div>
                    }
                    @case ('decimalNumber') {
                      <div>
                        @if (alert[column] > -1) {
                          <span>
                            {{ app.field.formatNumberWithDecimals(alert[column], 2) }}
                          </span>
                        }
                      </div>
                    }
                  }
                </div>
              </td>
            }
          </tr>
        }
        <tr>
          @if (loading) {
            <td colspan="99" class="text-center">
              {{ this.app.text.core.loading }}
            </td>
          }
          @if (!loading && app.alerts.allAlerts.length === 0) {
            <td
              colspan="99"
              class="text-center"
              >
              {{ app.text.app.noResults }}
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>

  <app-paginator
    [length]="app.alerts.allAlerts.length"
    [index]="app.paginator.focus"
    (focus)="app.paginator.focus = $event"
  ></app-paginator>
  <app-modal
    #seeWhereUsedTreeModal
    [modalTitle]="app.text.part.whereUsed"
    [showButtons]="false"
    [modalType]="'showWhereUsedTree'"
    [whereUsedCustomer]="app.customers.expectCurrent"
    [whereUsedPartNumber]="selectedWhereUsedPartNumber"
    >
  </app-modal>

  <app-modal
    #seeOpenedCasesModal
    [modalTitle]="app.text.thread.threads"
    [modalType]="'showListOfCases'"
    [showButtons]="false"
    >
  </app-modal>
